<div class="flex flex-row flex-wrap w-full items-center py-1 border-b border-gray-300 border-solid">
  <div style="width: 36px; height: 36px;"
       class="text-center bg-gray-100 self-center rounded-full h-9 w-9 m-2 relative">
                    <img [alt]="stateIcon.state" [src]="iconUrl"/>
  </div>
  <div class="text-gray-700 text-sm block font-normal uppercase mb-1">{{stateIcon.state}}</div>
  <div class="text-center m-2 ml-auto self-center">
    <dx-button
      stylingMode="text"
      text="Changer"
      type="normal"
      (onClick)="changeIconImg($event)">
    </dx-button>
  </div>
</div>
<input class="hidden" (change)="onIconUpload($event)" type="file" accept="image/*"
       #iconBtn>

